var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { Aspect_ } from '../../../../components/actor/Aspect_';
import { DraftLayoutBottom } from './DraftLayouBottom';
import { DraftLayoutMain } from './DraftLayoutMain';
let DraftLayout = class DraftLayout extends React.PureComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get templateOuter() {
        return (React.createElement("div", { key: "stage_outer", style: {
                flex: '1 1 auto',
                flexDirection: 'column',
                height: this.props.app.stage.draftLayout.outerHeightInCss,
                display: 'flex',
            } }));
    }
    render() {
        const { app, children } = this.props;
        return (React.createElement(Aspect_, { aspect: app.stage.outer, templateComponent: this.templateOuter },
            React.createElement(DraftLayoutMain, { app: app }, children),
            React.createElement(DraftLayoutBottom, { app: app })));
    }
};
__decorate([
    computed
], DraftLayout.prototype, "templateOuter", null);
DraftLayout = __decorate([
    observer
], DraftLayout);
export { DraftLayout };
